// extracted by mini-css-extract-plugin
module.exports = {"page":"Catering_page___jNeU","intro":"Catering_intro__wwNps","options":"Catering_options__7lOw0","contactLink":"Catering_contactLink__OgAiA","notice":"Catering_notice__8rKgN"};